import { Box, Flex, Stack, Text, useColorMode, useMediaQuery } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { updateForm } from '../../store/formReducer';
import { useStore } from "../../store/Store";
import { calculate } from '../../utils/calculator';
import { checkAmount, numberFormatter } from '../../utils/numberUtils';

function Result() {
    const [isNotSmallerScreen] = useMediaQuery("(min-width:600px)");
    const { colorMode } = useColorMode();
    const isDark = colorMode === "dark";
    const [state, dispatch] = useStore();

    const {amount, compoundingInterval, period, rate, principalAmount, oneTime, data} = state;
    const [principal, setPrincipal] = useState(principalAmount);
    // const [maturityAmt, setMaturityAmt] = useState(maturityAmount);

    let calculateResult = async () => {
        let data = [];
        

        if(oneTime) {
            // For one time investment ₹
            let principal_amount = amount;
            principal_amount = numberFormatter(principal_amount);
            await setPrincipal(principal_amount);
            let newState = {
                ...state,
                amount: 0,
                initialInvestment: amount,
            };
            data = calculate(newState);
            // console.log("Data=",data);
        }
        else {
            let principal_amount = amount * parseInt(12, 10) * parseInt(period, 10);
            principal_amount = numberFormatter(principal_amount);
            await setPrincipal(principal_amount);
            data = calculate(state);
            // console.log("Data=",data);
        }
        dispatch(updateForm('data', data))
        
    }

    const getTotalValue = () => {
        if (data.length > 0) {
            let finalMaturity = numberFormatter(data[data.length - 1].currentValue);
            return finalMaturity;
        }    
        else return 0;
    }

    useEffect(() => {
        calculateResult();
    }, [amount, compoundingInterval, period, rate, oneTime]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <Stack>
            <Flex rounded="xl" bg={isDark ? "gray.600" : "gray.100"} spacing="20px" py={isNotSmallerScreen ? "4" : "4"} px={isNotSmallerScreen ? "10" : "3"} justifyContent="space-between">
                <Box my="4" >
                    <Flex direction="column">
                        <Text fontSize="lg" fontWeight="bold" color={isDark ? "white.100" : "gray.700"}>{!checkAmount(amount) ? principal : `₹ 0`}</Text>
                        <Text fontSize="md" fontWeight="normal" color={isDark ? "white.100" : "gray.700"}>Principal Amount</Text>
                    </Flex>
                </Box>
                <Box m="4" >
                    <Text fontSize="xl" fontWeight="normal" color={isDark ? "white.100" : "gray.700"}>+</Text>
                </Box>
                <Box my="4" >
                    <Flex direction="column">
                        <Text fontSize="lg" fontWeight="bold" color={isDark ? "white.100" : "gray.700"}>{!checkAmount(amount) ? `${rate} %` : `0 %`}</Text>
                        <Text fontSize="md" fontWeight="normal" color={isDark ? "white.100" : "gray.700"}>Interest Rate</Text>
                    </Flex>
                </Box>
                <Box m="4" >
                    <Text fontSize="xl" fontWeight="normal" color={isDark ? "white.100" : "gray.700"}>=</Text>
                </Box>
                <Box my="4" >
                    <Flex direction="column">
                        <Text fontSize="lg" fontWeight="bold" color={isDark ? "white.100" : "gray.700"}>{!checkAmount(amount) ? getTotalValue() : `₹ 0`}</Text>
                        <Text fontSize="md" fontWeight="normal" color={isDark ? "white.100" : "gray.700"}>Maturity Amount</Text>
                    </Flex>
                </Box>
            </Flex>
        </Stack>
    )
}

export default Result
